/**
 * HighlightContext — 图谱高亮状态上下文
 *
 * 从 SkillTreeMap 独立出来，避免 Fast Refresh 警告
 * （react-refresh/only-export-components 要求文件只 export 组件）
 */
import { createContext } from 'react';

export const HighlightContext = createContext<{
  neighborhoodIds: Set<string> | null;
  searchMatchIds: Set<string> | null;
  filterMatchIds: Set<string> | null;
  selectedNodeId: string | null;
  companyRelatedIds: Set<string> | null;
} | null>(null);
